import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getWaterRightsList as getWaterRightsListApi,
	getWaterRightsQuery as getWaterRightsQueryApi,
	getWaterRights as getWaterRightsApi,
	addNewWaterRights as addNewWaterRightsApi,
	updateWaterRights as updateWaterRightsApi,
	deleteWaterRights as deleteWaterRightsApi,
} from '../../helpers/water_rights/backend_helper';

export const getWaterRightsList = createAsyncThunk('water_rights/getWaterRightsList', async (params) => {
	try {
		const response = getWaterRightsListApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getWaterRightsListQuery = createAsyncThunk('water_rights/getWaterRightsListQuery', async (params) => {
	try {
		const response = getWaterRightsQueryApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getWaterRights = createAsyncThunk('water_rights/getWaterRights', async water_rights_id => {
	try {
		const response = getWaterRightsApi(water_rights_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewWaterRights = createAsyncThunk('water_rights/addNewWaterRights', async (waterRights, { rejectWithValue }) => {
	try {
		const response = await addNewWaterRightsApi(waterRights);
		return response;
	} catch (error) {
		return rejectWithValue(error.response?.data || error.message || error);
	}
});

export const updateWaterRights = createAsyncThunk('water_rights/updateWaterRights', async (waterRights, { rejectWithValue }) => {
	try {
		const response = await updateWaterRightsApi(waterRights);
		return response;
	} catch (error) {
		return rejectWithValue(error.response?.data || error.message || error);
	}
});

export const deleteWaterRights = createAsyncThunk('water_rights/deleteWaterRights', async waterRights => {
	try {
		const response = await deleteWaterRightsApi(waterRights);
		toast.success('Derecho de Agua eliminado exitosamente.', { autoClose: 3000 });
		return { waterRights, ...response };
	} catch (error) {
		toast.error('Error al eliminar Derecho de Agua.', { autoClose: 3000 });
		throw new Error(error);
	}
}); 